module.exports = __webpack_public_path__ + "img/team-09.55c1cf4a.jpg";